'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactDom = require('react-dom');var _reactDom2 = _interopRequireDefault(_reactDom);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _CompanyTooltip = require('./CompanyTooltip.scss');var styles = _interopRequireWildcard(_CompanyTooltip);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

Tooltip = function (_Component) {_inherits(Tooltip, _Component);function Tooltip() {var _temp, _this, _ret;_classCallCheck(this, Tooltip);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.








































    container = null, _this.

    render = function () {return null;}, _temp), _possibleConstructorReturn(_this, _ret);}Tooltip.prototype.componentDidMount = function componentDidMount() {if (!this.container) {this.container = document.createElement('div');this.container.classList.add(styles.tooltip);this.container.classList.toggle('rtl', this.props.isRtl);document.body.appendChild(this.container);}this.componentDidUpdate();};Tooltip.prototype.componentDidUpdate = function componentDidUpdate() {if (!this.props.tooltipFor) return null;var bounds = this.props.tooltipFor.getBoundingClientRect();var displayFromRight = this.props.isRtl;var style = { top: bounds.top + Math.floor(bounds.height / 2) + 'px' };if (displayFromRight) {style.left = bounds.right + 'px';} else {style.right = document.body.offsetWidth - bounds.left + 'px';}_reactDom2.default.render(_react2.default.createElement('div', { style: style, className: 'tooltip-container' }, _react2.default.createElement('div', { className: 'tooltip-content' }, this.props.children)), this.container);return null;};Tooltip.prototype.componentWillUnmount = function componentWillUnmount() {document.body.removeChild(this.container);_reactDom2.default.unmountComponentAtNode(this.container);};return Tooltip;}(_react.Component);exports.default = Tooltip;


Tooltip.propTypes = {
  children: _propTypes2.default.oneOfType([
  _propTypes2.default.arrayOf(_propTypes2.default.node),
  _propTypes2.default.node,
  _propTypes2.default.object,
  _propTypes2.default.element]),

  tooltipFor: _propTypes2.default.oneOfType([
  _propTypes2.default.node,
  _propTypes2.default.object,
  _propTypes2.default.element]),

  isRtl: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/CompanyContactUs/CompanyTooltip/CompanyTooltip.js
// module id = 2613
// module chunks = 0